export const formatCurrency = (money = 0, format = 'NGN' ) => {
    const formattedAmount = new Intl.NumberFormat(`en-${format?.substring(0, 2)}`, {style: 'currency', currency: format}).format(money)
    return formattedAmount.replace('₦', 'NGN ')
}